import { render, staticRenderFns } from "./MarginEdit.vue?vue&type=template&id=455fc387"
import script from "./MarginEdit.vue?vue&type=script&lang=ts"
export * from "./MarginEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455fc387')) {
      api.createRecord('455fc387', component.options)
    } else {
      api.reload('455fc387', component.options)
    }
    module.hot.accept("./MarginEdit.vue?vue&type=template&id=455fc387", function () {
      api.rerender('455fc387', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/MarginEdit.vue"
export default component.exports